import React, { useRef, useState } from 'react'
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import UploadIcon from '@mui/icons-material/Upload'
import { useSnackbar } from 'notistack'
import { useImportMysteryShopperCompanies } from '../../../../api/promotions/dealer/mystery-shopper-company'

const ImportButton = () => {
  const fileInputRef = useRef(null)
  // Staged file awaiting confirmation; the confirm dialog is open while this is set.
  const [file, setFile] = useState(null)

  const { mutateAsync, isLoading } = useImportMysteryShopperCompanies()
  const { enqueueSnackbar } = useSnackbar()

  // Open the OS file picker.
  const handleClickImport = () => fileInputRef.current?.click()

  const handleFileChange = (ev) => {
    const selected = ev.target.files?.[0]
    // Clear the input so selecting the same file again still fires onChange.
    ev.target.value = ''
    if (selected) setFile(selected)
  }

  const handleCancel = () => setFile(null)

  const handleConfirm = async () => {
    const formData = new FormData()
    formData.append('file', file)
    setFile(null)

    try {
      const res = await mutateAsync(formData)

      enqueueSnackbar(res?.data?.message ?? 'Companies imported successfully', {
        variant: 'success',
      })
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.message ?? 'Failed to import companies', {
        variant: 'error',
        autoHideDuration: 7000,
      })
    }
  }

  return (
    <>
      <Button
        startIcon={isLoading ? <CircularProgress size='1.5rem' /> : <UploadIcon />}
        onClick={handleClickImport}
        disabled={isLoading}
      >
        Import Companies
      </Button>
      <input
        ref={fileInputRef}
        type='file'
        accept='.xlsx,.xls'
        hidden
        onChange={handleFileChange}
      />

      {/* Replace-all is destructive, so require explicit confirmation. */}
      <Dialog open={!!file} onClose={handleCancel} fullWidth>
        <DialogTitle>Replace all company data?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            This will permanently delete all existing companies and replace them with the contents
            of <strong>{file?.name}</strong>. The file must have <strong>Company Name</strong>,{' '}
            <strong>Address</strong>, and <strong>State</strong> columns. This action cannot be
            undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button onClick={handleConfirm} variant='contained' color='error'>
            Replace All
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ImportButton
